export const ISSUE_ROOT_CAUSES_FETCH_START = 'ISSUE_ROOT_CAUSES_FETCH_START';
export const ISSUE_ROOT_CAUSES_FETCH_API = 'ISSUE_ROOT_CAUSES_FETCH_API';
export const ISSUE_ROOT_CAUSES_FETCH_API_FULFILLED = 'ISSUE_ROOT_CAUSES_FETCH_API_FULFILLED';
export const ISSUE_ROOT_CAUSES_FETCH_API_REJECTED = 'ISSUE_ROOT_CAUSES_FETCH_API_REJECTED';
export const ISSUE_ROOT_CAUSES_CREATE_START = 'ISSUE_ROOT_CAUSES_CREATE_START';
export const ISSUE_ROOT_CAUSES_CREATE_API = 'ISSUE_ROOT_CAUSES_CREATE_API';
export const ISSUE_ROOT_CAUSES_CREATE_API_FULFILLED = 'ISSUE_ROOT_CAUSES_CREATE_API_FULFILLED';
export const ISSUE_ROOT_CAUSES_CREATE_API_REJECTED = 'ISSUE_ROOT_CAUSES_CREATE_API_REJECTED';
export const ISSUE_ROOT_CAUSES_UPDATE_TITLE_START = 'ISSUE_ROOT_CAUSES_UPDATE_TITLE_START';
export const ISSUE_ROOT_CAUSES_UPDATE_TITLE_API = 'ISSUE_ROOT_CAUSES_UPDATE_TITLE_API';
export const ISSUE_ROOT_CAUSES_UPDATE_TITLE_API_FULFILLED = 'ISSUE_ROOT_CAUSES_UPDATE_TITLE_API_FULFILLED';
export const ISSUE_ROOT_CAUSES_UPDATE_TITLE_API_REJECTED = 'ISSUE_ROOT_CAUSES_UPDATE_TITLE_API_REJECTED';
export const ISSUE_ROOT_CAUSES_UPDATE_STATUS_START = 'ISSUE_ROOT_CAUSES_UPDATE_STATUS_START';
export const ISSUE_ROOT_CAUSES_UPDATE_STATUS_API = 'ISSUE_ROOT_CAUSES_UPDATE_STATUS_API';
export const ISSUE_ROOT_CAUSES_UPDATE_STATUS_API_FULFILLED = 'ISSUE_ROOT_CAUSES_UPDATE_STATUS_API_FULFILLED';
export const ISSUE_ROOT_CAUSES_UPDATE_STATUS_API_REJECTED = 'ISSUE_ROOT_CAUSES_UPDATE_STATUS_API_REJECTED';
export const ISSUE_ROOT_CAUSES_DELETE_START = 'ISSUE_ROOT_CAUSES_DELETE_START';
export const ISSUE_ROOT_CAUSES_DELETE_API = 'ISSUE_ROOT_CAUSES_DELETE_API';
export const ISSUE_ROOT_CAUSES_DELETE_API_FULFILLED = 'ISSUE_ROOT_CAUSES_DELETE_API_FULFILLED';
export const ISSUE_ROOT_CAUSES_DELETE_API_REJECTED = 'ISSUE_ROOT_CAUSES_DELETE_API_REJECTED';
export const ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_START = 'ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_START';
export const ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API = 'ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API';
export const ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API_FULFILLED = 'ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API_FULFILLED';
export const ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API_REJECTED = 'ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_API_REJECTED';
export const ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_START = 'ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_START';
export const ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API = 'ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API';
export const ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API_FULFILLED = 'ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API_FULFILLED';
export const ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API_REJECTED = 'ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_API_REJECTED';
export const ISSUE_ROOT_CAUSES_TOGGLE_TITLE_EDITED_ROOT_CAUSE = 'ISSUE_ROOT_CAUSES_TOGGLE_TITLE_EDITED_ROOT_CAUSE';
export const ISSUE_ROOT_CAUSES_TOGGLE_ROOT_CAUSE_CATEGORY_IN_USE_MODAL =
  'ISSUE_ROOT_CAUSES_TOGGLE_ROOT_CAUSE_CATEGORY_IN_USE_MODAL';
export const ISSUE_ROOT_CAUSES_TOGGLE_ROOT_CAUSE_IN_USE_MODAL = 'ISSUE_ROOT_CAUSES_TOGGLE_ROOT_CAUSE_IN_USE_MODAL';

export const fetchIssueRootCausesAction = () => ({
  type: ISSUE_ROOT_CAUSES_FETCH_START
});

export const createIssueRootCauseCategoryAction = (payloadObj, meta) => ({
  type: ISSUE_ROOT_CAUSE_CATEGORIES_CREATE_START,
  payload: payloadObj,
  meta
});

export const createIssueRootCauseAction = payloadObj => ({
  type: ISSUE_ROOT_CAUSES_CREATE_START,
  payload: payloadObj
});

export const updateIssueRootCausesStatusAction = (id, isActive, parentId) => ({
  type: ISSUE_ROOT_CAUSES_UPDATE_STATUS_START,
  payload: {id, isActive, parentId}
});

export const updateIssueRootCausesTitleAction = (id, title, parentId) => ({
  type: ISSUE_ROOT_CAUSES_UPDATE_TITLE_START,
  payload: {id, title, parentId}
});

export const deleteIssueRootCauseCategoryAction = ({id, title, meta}) => ({
  type: ISSUE_ROOT_CAUSE_CATEGORIES_DELETE_START,
  payload: {id, title},
  meta
});

export const deleteIssueRootCauseAction = ({id, parentId, title, meta}) => ({
  type: ISSUE_ROOT_CAUSES_DELETE_START,
  payload: {id, parentId, title},
  meta
});

export const toggleTitleEditedIssueRootCauseAction = id => ({
  type: ISSUE_ROOT_CAUSES_TOGGLE_TITLE_EDITED_ROOT_CAUSE,
  payload: {id}
});

export const toggleRootCauseCategoryInUseModalAction = isOpen => ({
  type: ISSUE_ROOT_CAUSES_TOGGLE_ROOT_CAUSE_CATEGORY_IN_USE_MODAL,
  payload: {isOpen}
});

export const toggleRootCauseInUseModalAction = isOpen => ({
  type: ISSUE_ROOT_CAUSES_TOGGLE_ROOT_CAUSE_IN_USE_MODAL,
  payload: {isOpen}
});
